import axios from '@/plugins/axios'
import { pick as _pick, omit as _omit } from 'lodash'
import { MessageBox } from "element-ui";

export default {
    namespaced: true,

    state: {
        loading: false,
        brands: [],
        brand: {
            restrictions: [],
            smartLinks: [],
            assets: [],
            socials: []
        },
        showModal: false,
        modalAction: 'create',
        socials: [],
        restrictions: [],
        pricingThresholds: [],
        currentPage: 1,
        pageSize: 10,
        order: '',
        pdf_report: {},
        challenge_type:'',
        PieChartSettPdf: {
            width: 'auto',
            height: 290,
            is3D: false,
            pieSliceText: 'value',
            fontName: 'Nunito Bold',
            pieSliceTextStyle: {
                color: '#fff',
                fontSize: 15
            },
            legend: 'none',
            pieHole: 0.5,
            chartArea: {
                width: '90%',
                height: '90%'
            },
            tooltip: {
                textStyle: {
                    color: '#000',
                    fontSize: 14
                },
                showColorCode: true
            },
            colors: [
                '#4472C4',
                '#8687D2',
                '#B69FDF',
                '#DEBAEB',
                '#A9DAE7',
                '#A7E5FF',
                '#00CAFF',
                '#00F2EA',
                '#00D3A5',
                '#00FF00',
            ]
        }
    },

    mutations: {
        /**
         * @param state
         * @param bool
         */
        setLoader(state, bool) {
            state.loading = bool
        },

        /**
         * @param state
         * @param brands
         */
        setBrands(state, brands) {
            state.brands = brands
        },

        /**
         *
         * @param state
         * @param brand
         */
        setBrand(state, brand) {
            state.brand = brand
        },

        /**
         * @param state
         * @param bool
         */
        setModal(state, bool) {
            state.showModal = bool
        },

        /**
         * @param state
         * @param action
         */
        setModalAction(state, action) {
            state.modalAction = action
        },

        /**
         * @param state
         * @param timing
         */
        setTiming(state, timing) {
            state.brand.start_date = timing[0]
            state.brand.end_date = timing[1]
        },

        /**
         * @param state
         * @param socials
         */
        setSocials(state, socials) {
            state.socials = socials.filter(social => {
                return ['YouTube', 'YouTube Short', 'TikTok', 'Instagram'].includes(social.name)
            })
        },

        /**
         * @param state
         * @param restrictions
         */
        setRestrictions(state, restrictions) {
            state.restrictions = restrictions
        },

        /**
         * @param state
         * @param smartLinks
         */
        setSmartLinks(state, smartLinks) {
            state.brand.smartLinks = smartLinks
        },

        /**
         * @param state
         * @param imageUrl
         */
        setImage(state, imageUrl) {
            state.brand.image = imageUrl
        },
        /**
         *
         * @param state
         * @param imageUrl
         */
        setLogo(state, imageUrl) {
            state.brand.logo = imageUrl
        },

        /**
         * @param state
         * @param assets
         */
        setAssets(state, assets) {
            state.brand.assets = assets
        },

        /**
         * @param state
         * @param page
         */
        setCurrentPage(state, page) {
            state.currentPage = page
        },

        /**
         * @param state
         * @param perPage
         */
        setPageSize(state, perPage) {
            state.pageSize = perPage
        },

        /**
         * @param state
         * @param order
         */
        setOrder(state, order) {
            state.order = order
        },

        /**
         * @param state
         * @param pricingThresholds
         */
        setPricingThresholds(state, pricingThresholds) {
            state.pricingThresholds = pricingThresholds
        },

        /**
         * @param state
         * @param data
         */
        setChallengeDate(state, data) {
            let challenge = { ...state.brand[data.type] }

            challenge.date_start = data.date[0]
            challenge.date_end = data.date[1]

            state.brand[data.type] = challenge
        },
        /**
         *
         * @param state
         * @param payload
         */
        setPdfShortsReport(state, payload) {
            state.pdf_report = payload,
              state.challenge_type = 'Shorts'
        },
        /**
         *
         * @param state
         * @param payload
         */
        setPdfTikTokReport(state, payload) {
            state.pdf_report = payload
            state.challenge_type = 'TikTok'
        },
        /**
         *
         * @param state
         * @param payload
         */
        setPdfInstagramReport(state, payload) {
            state.pdf_report = payload
            state.challenge_type = 'Instagram'
        },
    },

    actions: {
        /**
         * @param commit
         * @param state
         * @returns {Promise<void>}
         */
        async getBrands({ commit, state }) {
            try {
                commit('setLoader', true)

                const queryBuilder = state.order
                    ? `?${state.order}` + `&page=${state.currentPage}&perPage=${state.pageSize}`
                    : `?page=${state.currentPage}&perPage=${state.pageSize}`

                const { data } = await axios.admin.get('brands' + queryBuilder)

                if (data) commit('setBrands', data.brands)
            } catch (e) {
                console.error(e)
            } finally {
                commit('setLoader', false)
            }
        },

        /**
         * @param dispatch
         * @param commit
         * @param state
         * @returns {Promise<void>}
         */
        async createOrUpdateBrand({ dispatch, commit, state }) {
            try {
                if (!['create', 'update'].includes(state.modalAction)) return
                commit('setLoader', true)

                let formData = new FormData()

                formData.append('image', state.brand.image)
                formData.append('logo', state.brand.logo)

                formData.append('short_challenge_video', state.brand.short_challenge.video)
                formData.append('youtube_regular_video', state.brand.youtube_regular.youtube_video)
                formData.append('tiktok_challenge_video', state.brand.tiktok_challenge.video)
                formData.append('instagram_challenge_video', state.brand.instagram_challenge.video)

                // Constructing FormData for Instagram assets
                if (state.brand.instagram_challenge && state.brand.instagram_challenge.assets) {
                    state.brand.instagram_challenge.assets.forEach(asset => {
                        if (asset.path instanceof File) {
                            formData.append('instagram_challenge_new_assets[]', asset.path);
                        }
                    });
                }

                // Constructing FormData for TikTok assets
                if (state.brand.tiktok_challenge && state.brand.tiktok_challenge.assets) {
                    state.brand.tiktok_challenge.assets.forEach(asset => {
                        if (asset.path instanceof File) {
                            formData.append('tiktok_challenge_new_assets[]', asset.path);
                        }
                    });
                }

                // Constructing FormData for Shorts assets
                if (state.brand.short_challenge && state.brand.short_challenge.assets) {
                    state.brand.short_challenge.assets.forEach(asset => {
                        if (asset.path instanceof File) {
                            formData.append('short_challenge_new_assets[]', asset.path);
                        }
                    });
                }

                // Constructing FormData for YouTube assets
                if (state.brand.youtube_regular && state.brand.youtube_regular.assets) {
                    state.brand.youtube_regular.assets.forEach(asset => {
                        if (asset.path instanceof File) {
                            formData.append('youtube_regular_new_assets[]', asset.path);
                        }
                    });
                }


                formData.append('payload', JSON.stringify({..._pick(state.brand, [
                    'name', 'company_name', 'socials', 'smartLinks', 'restrictions', 'description','card_bar_desc',
                    'start_date', 'end_date', 'featured', 'affiliate_generator', 'short_challenge'
                ]), short_challenge: _omit(state.brand.short_challenge, ['video']),
                    youtube_regular: _omit(state.brand.youtube_regular, ['youtube_video']),
                    tiktok_challenge: _omit(state.brand.tiktok_challenge, ['video']),
                    instagram_challenge: _omit(state.brand.instagram_challenge, ['video'])
                }))

                let url = 'brands' + (state.modalAction === 'update' ? `/${state.brand.id}` : '')

                const { data } = await axios.admin.post(url, formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                })
                if (data.success) {
                    dispatch('getBrands')
                    commit('setModal', false)
                }
            }
            catch (e) { console.error(e) }
            finally { commit('setLoader', false) }
        },

        /**
         * @param dispatch
         * @param brandId
         * @returns {Promise<void>}
         */
        async deleteBrand({ dispatch }, brandId) {
            try {
                const response = await MessageBox.confirm(
                    'Do you really want to delete this brand?',
                    'Delete Brand', {
                        confirmButtonText: 'Yes', cancelButtonText: 'No', type: 'warning'
                    }
                )
                if (response) {
                    const { data } = await axios.admin.delete(`brands/${brandId}`)

                    if (data.success) dispatch('getBrands')
                }
            } catch (e) {
                console.error(e)
            }
        },

        /**
         * @param dispatch
         * @param payload
         * @returns {Promise<void>}
         */
        async publish({ dispatch }, payload) {
            try {
                const { brandId, status } = payload
                const statusToText = status === 1 ? 'publish' : 'unpublish'


                const response = await MessageBox.confirm(
                    `Do you really want to ${statusToText} this brand?`,
                    `${statusToText.charAt(0).toUpperCase() + statusToText.slice(1)} Brand`, {
                        confirmButtonText: 'Yes', cancelButtonText: 'No', type: 'warning'
                    }
                )
                if (response) {
                    const { data } = await axios.admin.post(`brands/publish/${brandId}/${status}`)
                    if (data.success) dispatch('getBrands')
                }
            } catch (e) {
                console.error(e)
            }
        },

        /**
         * @param commit
         * @returns {Promise<void>}
         */
        async getSocials({ commit }) {
            try {
                const { data } = await axios.api.get('socials')
                if (data) commit('setSocials', data)
            } catch (e) {
                console.error(e)
            }
        },

        /**
         * @param commit
         * @returns {Promise<void>}
         */
        async getRestrictions({ commit }) {
            try {
                const { data } = await axios.api.get('restrictions')
                if (data) commit('setRestrictions', data.restrictions)
            } catch (e) {
                console.error(e)
            }
        },

        /**
         * @param commit
         * @returns {Promise<void>}
         */
        async getPricingThresholds({ commit }) {
            try {
                const { data } = await axios.api.get('challenge/pricing')
                if (data) commit('setPricingThresholds', data.pricing)
            } catch (e) {
                console.error(e)
            }
        },
        /**
         *
         * @param commit
         * @param send
         * @returns {Promise<unknown>}
         */
        readShortsReport({ commit }, send) {
            return new Promise((resolve, reject) => {
                axios.api
                  .get(`report/challenge/shorts/${send.id}`, {
                      params: {
                          type: 'brand',
                      }
                  })
                  .then(r => {
                      commit('setPdfShortsReport', r.data.data)
                      resolve()
                  })
                  .catch(e => {
                      console.log(e)
                      reject(e)
                  })
            })
        },
        /**
         *
         * @param commit
         * @param send
         * @returns {Promise<unknown>}
         */
        readTikTokReport({ commit }, send) {
            return new Promise((resolve, reject) => {
                axios.api
                  .get(`report/challenge/tiktok/${send.id}`, {
                      params: {
                          type: 'brand',
                      }
                  })
                  .then(r => {
                      commit('setPdfTikTokReport', r.data.data)
                      resolve()
                  })
                  .catch(e => {
                      console.log(e)
                      reject(e)
                  })
            })
        },
        /**
         *
         * @param commit
         * @param send
         * @returns {Promise<unknown>}
         */
        readInstagramReport({ commit }, send) {
            return new Promise((resolve, reject) => {
                axios.api
                  .get(`report/challenge/instagram/${send.id}`, {
                      params: {
                          type: 'brand',
                      }
                  })
                  .then(r => {
                      commit('setPdfInstagramReport', r.data.data)
                      resolve()
                  })
                  .catch(e => {
                      console.log(e)
                      reject(e)
                  })
            })
        }
    },
    getters: {
        countries_chart: state => {
            let result = []
            if (state.pdf_report.countries) {
                result = [['Task', 'Hours per Day']]
                state.pdf_report.countries.map(s => {
                    result.push([s.country, Number(s.count)])
                })
            }
            return result
        }
    }
}
